module.exports = __webpack_public_path__ + "img/itx-file-type-odt.ff0377d5.svg";